<template>
	<div>
		<app-header></app-header>
		<div class="row page-header">
			<div class="container">
			<img class="header-background-icon" src="../../assets/images/freelancer-icon.png">
			<div class="col-sm-12"><h1 class="page-title">Find a freelancer</h1></div>
			<div class="col-sm-12"><h6 class="page-sub-title">Browse all of our freelancers and find the perfect done for you</h6></div>
			</div>
		</div>

		<div class="row filter-container">
			<div class="col-sm-3">
				<h5>Categories</h5>
				<el-tree 
					:data="filterCategories" 
					:props="defaultProps" 
					@node-click="handleNodeClick"
					show-checkbox></el-tree>

				<h5>Design level</h5>
				<el-tree 
					:data="filterLanguage" 
					:props="defaultProps" 
					@node-click="handleNodeClick"
					show-checkbox></el-tree>

				<h5>Job Success</h5>
				<el-tree 
					:data="filterDesignLevel" 
					:props="defaultProps" 
					@node-click="handleNodeClick"
					show-checkbox></el-tree>

				<h5>Hourly rate</h5>
				<el-tree 
					:data="filterHourlyRate" 
					:props="defaultProps" 
					@node-click="handleNodeClick"
					show-checkbox></el-tree>
			</div>

			<div class="col-sm-8">
				<div class="row applied-filters">
					<div class="col-sm-12">
						<span>Applied filters: &nbsp;</span>

						<button class="btn btn-outline-default">
							<i class="fa fa-times"></i> &nbsp;Delivery time: 1 day</button>

						<button class="btn btn-outline-default">
							<i class="fa fa-times"></i> &nbsp;Category: Desing and Creative
						</button>
					</div>
				</div>

				<div class="row filters-meta-data">
					<div class="col-sm-6">
						<span><b>4</b> freelancers found</span>
					</div>

					<div class="col-sm-6">
						<div class="sort-controls pull-right">
							Sort by: 
							<el-dropdown trigger="click" @command="changeDropdown">
								<span class="el-dropdown-link">
		        					<b>{{sortBy}}</b><i class="el-icon-caret-bottom el-icon--right"></i>
		      					</span>

		      					<el-dropdown-menu slot="dropdown" command="test">
		      						<el-dropdown-item command="Best selling">Best selling</el-dropdown-item>
		      						<el-dropdown-item command="Price">Price</el-dropdown-item>
		      					</el-dropdown-menu>
							</el-dropdown>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-sm-4">
						<router-link to="/freelancer/1">
							<div class="profile">
								<img src="../../assets/images/temporary/freelance-project.png">

								<div class="profile-info">
									<img class="profile-picture" src="../../assets/images/temporary/freelacer-profile-picture.png">
									<h5>Ivan Abadzhiev</h5>
								</div>

								<span>4.97 stars, 21 completed projects</span>
								<p class="freelancer-skills">Illustration or graphics, Character or mascot. T-shirt</p>
							</div>
						</router-link>

					</div>

					<div class="col-sm-4">
						<router-link to="/freelancer/1">
							<div class="profile">
								<img src="../../assets/images/temporary/freelance-project-2.png">

								<div class="profile-info">
									<img class="profile-picture" src="../../assets/images/temporary/freelacer-profile-picture.png">
									<h5>Ivan Abadzhiev</h5>
								</div>

								<span>4.97 stars, 21 completed projects</span>
								<p class="freelancer-skills">Illustration or graphics, Character or mascot. T-shirt</p>
							</div>
						</router-link>
					</div>

					<div class="col-sm-4">
						<router-link to="/freelancer/1">
							<div class="profile">
								<img src="../../assets/images/temporary/freelance-project-3.png">

								<div class="profile-info">
									<img class="profile-picture" src="../../assets/images/temporary/freelacer-profile-picture.png">
									<h5>Ivan Abadzhiev</h5>
								</div>

								<span>4.97 stars, 21 completed projects</span>
								<p class="freelancer-skills">Illustration or graphics, Character or mascot. T-shirt</p>
							</div>
						</router-link>
					</div>

					<div class="col-sm-12">
						<hr>
					</div>

					<div class="col-sm-4">
						<router-link to="/freelancer/1">
							<div class="profile">
								<img src="../../assets/images/temporary/freelance-project.png">

								<div class="profile-info">
									<img class="profile-picture" src="../../assets/images/temporary/freelacer-profile-picture.png">
									<h5>Ivan Abadzhiev</h5>
								</div>

								<span>4.97 stars, 21 completed projects</span>
								<p class="freelancer-skills">Illustration or graphics, Character or mascot. T-shirt</p>
							</div>
						</router-link>
					</div>
				</div>

				<div class="row">
					<div class="col-sm-4"></div>
					<div class="col-sm-4 pagination-holder">
						<el-pagination
						  background
						  layout="prev, pager, next"
						  :total="1">
						</el-pagination>
					</div>
					<div class="col-sm-4"></div>
				</div>
			</div>
		</div>

		<div class="row">&nbsp;</div>
		<div class="row">&nbsp;</div>

		<footer-actions></footer-actions>
		<app-footer></app-footer>
	</div>
</template>

<script type="text/javascript">
import Header from '../Header';
import FooterActions from '../FooterActions';
import Footer from '../Footer';

export default {
	data() {
		return {
			sortBy : 'Best selling',
			filterCategories: [{
	          label: 'Web Developers',
	          children: [
	          {
	            label: 'Animation'
	          },
	          {
	          	label: 'Graphic design'
	          },
	          {
	          	label: 'Illustration'
	          },
	          {
	          	label: 'Design'
	          }]
	        }, {
	          	label: 'Mobile developers',
	        }, {
	          	label: 'Designers&Creative',
	        },{
	        	label : 'Writers'
	        },{
	        	label : 'Digital marketing'
	        },{
	        	label : 'Architecture'
	        }, {
	        	label : 'Interior'
	        }, {
	        	label : 'Music'
	        }, {
	        	label : 'Video&Animations'
	        }],
	        filterDesignLevel : [{
	        	label : 'Top level'
	        },{
	        	label : 'Mid level'
	        }, {
	        	label : 'Entry level'
	        }],
	        filterLanguage : [{
	        	label : 'Dutch'
	        },{
	        	label : 'English'
	        },{
	        	label : 'French'
	        },{
	        	label : 'German'
	        }, {
	        	label : 'Indonesiaa'
	        }, {
	        	label : 'Italian'
	        }],
	        filterHourlyRate : [{
	        	label : 'Any hourly rate'
	        }, {
	        	label : '$10 and below'
	        }, {
	        	label : '$10 - $30'
	        }, {
	        	label : '$30 - $60'
	        }, {
	        	label : '$60 & above'
	        }],
	        defaultProps: {
	          children: 'children',
	          label: 'label'
	        }
		}
	},
	methods : {
		changeDropdown(command) {
			this.sortBy = command;
		},
		handleCheckChange() {

		}
	},
	components: {
		appHeader : Header,
		footerActions : FooterActions,
		appFooter : Footer
	}
}
</script>

<style type="text/css" scoped>
@import '../../assets/css/stylesheet.css';

.freelancer-skills {
	font-size: 0.8em;
}

.profile-picture {
	width: 2em;
}

.profile-info {
	margin-top: 1em;
}

h5 {
	display: inline;
}

.applied-filters {
	background-color: #F3F3F3;
	margin-bottom: 2em;
	margin-top: 0.9em;
	margin-bottom: 0.9em;
}

.applied-filters div {
	padding: 0.8em;
}

.btn-outline-default {
	background-color: #FFF;
	font-size: 0.8em;
}

.filter-container {
	margin-top:2em;
}

.filters-meta-data {
	margin-bottom: 1.3em;
}

.sort-controls {
	text-align: right;
	cursor: pointer;
}

a {
	text-decoration: none;
	color : #000;
}

.pagination-holder {
	text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/freelancer/FreelancerSearch.vue